import { inject, Injectable } from '@angular/core';
import { AppState, AuthService, LogoutOptions, RedirectLoginOptions } from "@auth0/auth0-angular";
import { Browser } from "@capacitor/browser";
import { Capacitor } from "@capacitor/core";
import { firstValueFrom } from "rxjs";
import { environment } from '@envs/environment';
import { AlertService } from "./alert.service";
import { OrderService } from "./order.service";

@Injectable({
    providedIn: 'root'
})
export class LoginService {
    private _isNative = Capacitor.isNativePlatform();
    private readonly _orderService = inject(OrderService);

    constructor(
        private auth: AuthService,
        private _alert: AlertService
    ) {
    }

    logout() {
        const returnTo = this._isNative ? environment.auth0CallbackUrl : environment.logoutUrl;
        const logoutOptions: LogoutOptions = {logoutParams: {returnTo}};
        if (this._isNative) logoutOptions.openUrl = this._openUrl;
        this.auth.logout(logoutOptions);
    }

    async tryUserInitiatedLogout(): Promise<void> {
        const phase = this._orderService.routingPhase();
        if (phase === 'resume' || phase === 'inFlight') {
            await this._alert.warn("You can't log out while an order is being processed. Please wait for the order to complete.");
            return;
        }
        this.logout();
    }

    async login() {
        try {
            console.log('login: isNative=', this._isNative);
            const redirectLoginOptions: RedirectLoginOptions<AppState> = {
                openUrl: this._isNative ? this._openUrl : undefined,
            };
            await firstValueFrom(this.auth.loginWithRedirect(redirectLoginOptions));
        } catch (e) {
            await this._alert.warn(`Login failed, ${e.message}`);
        }
    }

    private async _openUrl(url: string) {
        await Browser.open({url, windowName: '_self'});
    }
}
